import script from "./FAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=5568bbcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5568bbcf"]])

export default __exports__